var render = function render(){var _vm=this,_c=_vm._self._c;return _c('wizard',{staticClass:"wizard-no-child-benefits",attrs:{"first-step":"info"}},[_c('wizard-step',{attrs:{"i18n":_vm.i18n,"name":"info","model":_vm.formData}},[_c('wizard-step-intro',[_c('h2',[_vm._v(_vm._s(_vm.i18n.wizardSteps.info.title))]),_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }